export default {
  isDebug: false,
  api_server: "https://paws-admin.nsardakent.org.uk/api",
  googleAnalyticsTag: "G-L7FWF495KF"
};
